import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Main from "./Main";
import { useGetRateAdjustmentCaseContentQuery } from "../../features/api";
import { RateAdjustmentCaseContentCode } from "../../features/api-interfaces";

//各APIによるデータ取得
export const Update = () => {
  // //料率調整内容取得API呼び出し
  const { rateAdjustmentCaseNo, merchantBranchNo, adjustmentBranchNo } =
    useParams();
  //取得API用パラメータ要素
  const corpNum: RateAdjustmentCaseContentCode = {
    rateAdjustmentCaseNo: Number(rateAdjustmentCaseNo),
    merchantBranchNo: Number(merchantBranchNo),
    adjustmentBranchNo: Number(adjustmentBranchNo),
  };

  const { data, refetch } = useGetRateAdjustmentCaseContentQuery(corpNum);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return <Main rateAdjustmentCaseData={data} corpNum={corpNum} />;
};
